<template>
  <cg_mask class="login_container">
    <div class="main" v-if="isShowLoginByPhone">
      <div class="close_btn" @click="$emit('close')"></div>
      <p class="title">登录</p>
      <div :class="{ input_wrap: true, input_wrap_error: mobileErrorMsg != '' }">
        <div class="prepend">+86</div>
        <div class="line"></div>
        <input
          type="text"
          placeholder="请输入手机号码"
          inputmode="numeric"
          @input="checkInputMobile"
          v-model="mobile"
        />
        <p class="error_msg">{{ mobileErrorMsg }}</p>
      </div>
      <div class="input_wrap sms_code_wrap">
        <input
          type="text"
          placeholder="请输入验证码"
          inputmode="numeric"
          @input="checkInputCode"
          v-model="sms_code"
        />
        <div class="line"></div>
        <div :class="{ afterpend: true, disabled: sendCodeDisabled }" @click="startInterval">
          {{ codeText }}
        </div>
        <p class="error_msg">{{ codeErrorMsg }}</p>
      </div>
      <div class="tips_con">
        <img
          class="checkbox"
          @click="cacheLogin = !cacheLogin"
          :src="cacheLogin ? checkBoxIcons.active : checkBoxIcons.normal"
          alt=""
        />
        <span>7天免登录</span>
      </div>
      <div class="tips_con">
        <img
          class="checkbox"
          @click="setAgree"
          :src="agree ? checkBoxIcons.active : checkBoxIcons.normal"
          alt=""
        />
        <span
          >我已阅读并同意<a
            target="_blank"
            href="https://legal.centurygames.cn/termsofservice_wjdr.html"
            >《用户协议》</a
          >及<a href="https://legal.centurygames.cn/privacy_wjdr.html" target="_blank"
            >《隐私条款》</a
          ></span
        >
        <p class="error_msg">{{ agreeErrorMsg }}</p>
      </div>
      <div class="btn_wrapper">
        <div
          :class="{
            login_btn: true,
            disabled: loginDisabled,
          }"
          @click="loginByPhone"
        >
          登录
        </div>

        <template v-if="loginWays.indexOf('app') > -1 && detectDeviceType()">
          <div v-if="isUseWechatJump && this.agree" class="loginByApp_btn">
            <img class="prve_icon" src="./image/loginByApp.png" alt="" /> 授权登录
            <wx-open-launch-app
              style="position: absolute; top: 0; left: 0; right: 0; bottom: 0"
              id="launch-btn"
              appid="wx32374c9038cf9759"
              :extinfo="wxJumpParams"
              @launch="showAuthLoading"
              @error="wechatJumpError"
            >
              <script type="text/wxtag-template">
                <style>
                  .wx_jumo_app_con {
                    width: 300px;
                    height: 300px;
                    opacity: 0
                  }</style>
                <div class="wx_jumo_app_con"></div>
              </script>
            </wx-open-launch-app>
          </div>
          <div v-else class="loginByApp_btn" @click="loginByApp">
            <img class="prve_icon" src="./image/loginByApp.png" alt="" /> 授权登录
          </div>
        </template>

        <div class="other_login" v-if="loginWays.length > 0">
          <img
            class="login_icon"
            v-if="loginWays.indexOf('app') > -1"
            @click="showErweima"
            src="./image/erweima_icon.png"
            alt=""
          />
          <template v-if="isMobile">
            <img
              class="login_icon"
              v-if="loginWays.indexOf('wechat') > -1"
              @click="showWxErweima"
              src="./image/wx_icon.png"
              alt=""
            />
          </template>
          <template v-else>
            <img
              class="login_icon"
              v-if="loginWays.indexOf('wechat') > -1 && showWechatScan"
              @click="showWxErweima"
              src="./image/wx_icon.png"
              alt=""
            />
          </template>
        </div>
      </div>
    </div>
    <div class="authorize_loading" v-show="isShowAuthorizeLoading">
      <div class="close_btn" @click="closeAuthLoading"></div>
      <div class="bg_con">
        <img class="bg_item" src="./image/authorize_loading_bg.png" alt="" />
        <img class="bg_icon" src="./image/authorize_loading_icon.png" alt="" />
        <p class="bg_text">授权中</p>
      </div>
      <p class="tips">
        请确保本地已安装游戏，如游戏未响应或授权失败，请将游戏升级到最新版本或更换其他浏览器
      </p>
    </div>
    <div class="authorize_fail" v-if="isShowAuthorizeFail">
      <div class="close_btn" @click="$emit('close')"></div>
      <div class="bg_con">
        <img class="bg_item" src="./image/authorize_fail_bg.png" alt="" />
        <p class="bg_text">授权失败</p>
      </div>
      <p class="tips">授权失败，请重试。</p>
    </div>
    <erweimaLogin
      v-if="isShowErweima"
      @close="$emit('close')"
      @toggleByPhone="toggleByPhone"
      @success="scanSucess"
      :createSession="createSession"
      :checkSessionStatus="checkSessionStatus"
    />
    <wxerweimaLogin
      v-if="isShowWxErweima"
      @close="$emit('close')"
      @toggleByPhone="toggleByPhone"
      @success="scanSucess"
      :createSession="createSession"
      :checkSessionStatus="checkSessionStatus"
      :wxReturnUrl="wxReturnUrl"
      :wxLoginAppId="wxLoginAppId"
    />
    <cg_mask
      class="wechat_guide_con"
      v-if="openExternalBrowserGuide"
      @clickMask="openExternalBrowserGuide = false"
    >
      <img class="wechat_guide_pic" src="./image/wechat_guide.png" alt="" />
    </cg_mask>
    <Notice
      ref="notice"
      :content="noticeinfo.content"
      :canceltext="noticeinfo.canceltext"
      :oktext="noticeinfo.oktext"
      :success="noticeinfo.success"
      :cancel="noticeinfo.cancel"
      :title="noticeinfo.title"
    ></Notice>
  </cg_mask>
</template>
<script>
import { debounce } from '@plaformWeb/web-utils'
import Notice from '../notice.vue'

import checkbox_active from './image/checkbox_active.png'
import checkbox from './image/checkbox.png'

import erweimaLogin from './erweimaLogin.vue'
import wxerweimaLogin from './wxerweimaLogin.vue'

import { isMobileDevice } from '@plaformWeb/web-utils'

const errMsgMap = {
  mobileReuqired: '请输入您的手机号码',
  codeReuqired: '请输入验证码',
  mobileRule: '手机号码格式不符',
  codeRequired: '请输入验证码',
  codeRule: '验证码格式不符',
  agree: '请阅读并勾选协议',
}

export default {
  props: {
    /**
     * 发送短信验证码，返回值类型是Promise
     */
    sendCode: {
      type: Function,
      required: true,
    },
    /**
     * 除手机号登录之外的，显示的登录方式列表
     * 全量的登录方式列表： [ 'wechat', 'app' ]
     */
    loginWays: {
      type: Array,
      required: true,
      default: [],
    },
    /**
     * pc端微信扫码是否展示
     */
    showWechatScan: {
      type: Boolean,
      default: true,
    },
    /**
     * 获取sesson以及deeplink
     * 返回值类型 Promise<{
     *  session_id: string,
     *  universal_link: string,
     *  schme: string
     * }>
     */
    createSession: {
      type: Function,
    },
    /**
     * 获取sesson状态
     * 返回值类型 Promise<{
     *  status: number
     * }>
     */
    checkSessionStatus: {
      type: Function,
    },
    /**
     * 微信登录成功后的跳转地址，会携带code以及login_type=wechat_pc
     */
    wxReturnUrl: {
      type: String,
      required: false,
      default: () => {
        return window.location.href.split('?')[0]
      },
    },
    /**
     * 微信网页授权登录appid
     */
    wxLoginAppId: {
      type: String,
      required: true,
    },
  },
  components: {
    Notice,
    erweimaLogin,
    wxerweimaLogin,
  },
  data() {
    return {
      isMobile: isMobileDevice(),
      checkBoxIcons: {
        normal: checkbox,
        active: checkbox_active,
      },
      // 缓存登录
      cacheLogin: true,
      // 隐私条款
      agree: false,
      // 验证码
      sms_code: '',
      // 手机号
      mobile: '',
      timer: null,
      codeText: '获取',
      // 是否正在发送验证码
      isSendingCode: false,
      // 手机号错误提示文案
      mobileErrorMsg: '',
      // 验证码错误提示文案
      codeErrorMsg: '',
      // 隐私条款错误提示文案
      agreeErrorMsg: '',
      captchaEncrypted: '',
      // 是否在微信内置浏览器
      isWeChat: navigator.userAgent.toLowerCase().includes('micromessenger'),
      // 是否在安卓
      isAndroid: navigator.userAgent.toLowerCase().includes('android'),
      // 内引导外部浏览器打开
      openExternalBrowserGuide: false,
      // 授权登录按钮点击后的授权中弹窗
      isShowAuthorizeLoading: false,
      // 授权登录按钮点击后的授权失败弹窗
      isShowAuthorizeFail: false,
      isShowLoginByPhone: true,
      isShowErweima: false,
      isShowWxErweima: false,
      noticeinfo: {
        content: '',
        success: null,
        cancel: 0,
      },
      // app授权登录信息，主要是跳转app的 unlink以及scheme
      appAuthInfo: {},
    }
  },
  computed: {
    loginDisabled() {
      return (
        this.agreeErrorMsg ||
        this.codeErrorMsg ||
        this.mobileErrorMsg ||
        !this.mobile ||
        !this.sms_code ||
        !this.agree
      )
    },
    sendCodeDisabled() {
      return !this.mobile || this.mobileErrorMsg || this.isSendingCode
    },
    // 只有安卓微信内需要使用微信开放标签拉起app
    isUseWechatJump() {
      return this.isWeChat && this.isAndroid
    },
    wxJumpParams() {
      return JSON.stringify({
        deep_link: this.appAuthInfo.scheme,
        action: 'webshop_cn_login',
      })
    },
  },
  watch: {
    // 授权中弹窗关闭时停止状态查询
    isShowAuthorizeLoading(val) {
      if (val) {
        window.addEventListener('visibilitychange', this.getSessionStatus)
      } else {
        window.removeEventListener('visibilitychange', this.getSessionStatus)
      }
    },
  },
  mounted() {
    if (this.detectDeviceType()) {
      //如果是微信同时配置了 app授权登录则创建session
      var iswechat = navigator.userAgent.toLowerCase().includes('micromessenger')
      if (iswechat && loginWays.indexOf('app') > -1) {
        this.getAppJumpSession()
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    window.removeEventListener('visibilitychange', this.getSessionStatus)
  },
  methods: {
    //
    // 是否是移动端
    detectDeviceType() {
      var dt =
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
          navigator.userAgent
        )
          ? 'Mobile'
          : 'PC'
      //判断pad
      if (window.innerWidth < 1024) {
        dt = 'Mobile'
      }

      return dt
    },
    opennotice(msg, fn, cancel, oktext, canceltext, title, sty) {
      this.noticeinfo = {
        content: msg,
        success: fn,
        cancel: cancel,
        oktext: oktext,
        canceltext: canceltext,
        title: title,
        sty: sty,
      }
      this.$refs.notice.open()
    },
    // 获取app授权session信息
    async getAppJumpSession() {
      const res = await this.createSession('app')
      this.appAuthInfo = res
    },
    // native原生方式，跳转app授权登录，universal_link或者scheme
    async loginByApp() {
      if (!this.agree) {
        return (this.agreeErrorMsg = errMsgMap.agree)
      }

      //非微信浏览器环境下
      const res = await this.createSession('app')
      this.appAuthInfo = res

      const userAgent = navigator.userAgent

      if (this.isAndroid) {
        if (userAgent.includes('Baidu')) {
          return this.$toast('当前浏览器不支持授权登录，建议用其他浏览器')
        } else {
          window.location.href = this.appAuthInfo.scheme
        }
      } else {
        if (userAgent.includes('Quark') || userAgent.includes('UCBrowser')) {
          window.location.href = this.appAuthInfo.scheme
        } else {
          window.location.href = this.appAuthInfo.universal_link
        }
      }
      this.isShowAuthorizeLoading = true
      this.isShowLoginByPhone = false
    },
    // 轮询更新session状态
    async getSessionStatus() {
      if (document.hidden) return
      const res = await this.checkSessionStatus(this.appAuthInfo.session_id)

      // 取消授权或者授权失败展示授权失败ui
      if (res.status === 3 || res.status === 5) {
        this.isShowAuthorizeFail = true
        this.isShowAuthorizeLoading = false
      }
      // 授权成功,通知父组件同步登录态
      if (res.status === 4) {
        this.appSuccess()
      }
    },

    // 展示二维码登录面板
    showErweima() {
      if (!this.agree) {
        return (this.agreeErrorMsg = errMsgMap.agree)
      }
      this.isShowErweima = true
      this.isShowLoginByPhone = false
    },
    //展示微信二维码登录面板
    showWxErweima() {
      //是移动端
      var iswechat = navigator.userAgent.toLowerCase().includes('micromessenger')
      if (this.detectDeviceType() == 'Mobile' && !iswechat) {
        //提示不支持
        this.$toast('请在微信客户端打开链接，再进行微信登录。', 2000, 'no_show_error')
        return false
      }

      if (!this.agree) {
        return (this.agreeErrorMsg = errMsgMap.agree)
      }

      //如果是微信浏览器中
      if (iswechat) {
        localStorage.setItem('wx_catchis', this.cacheLogin)
        let url = this.wxReturnUrl
        if (url.indexOf('?') > -1) {
          url +=
            '&login_type=wechat_mobile&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirec'
        } else {
          url +=
            '?login_type=wechat_mobile&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirec'
        }
        window.open(
          encodeURI(
            `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx34c1ca1e6b16c029&redirect_uri=${url}`
          )
        )
      } else {
        //pc端扫码
        this.isShowWxErweima = true
        this.isShowLoginByPhone = false
      }
    },
    // 切换手机号登录面板
    toggleByPhone() {
      this.isShowErweima = false
      this.isShowWxErweima = false
      this.isShowLoginByPhone = true
    },
    // 用户手动关闭授权中弹窗，校验授权状态，成功，则关闭且同步登录态
    async closeAuthLoading() {
      const res = await this.checkSessionStatus(this.appAuthInfo.session_id)

      // 授权成功,通知父组件同步登录态
      if (res.status === 4) {
        this.appSuccess()
      } else {
        this.isShowAuthorizeLoading = false
        this.isShowLoginByPhone = true
      }
    },

    checkInputCode(event) {
      const value = event.target.value
      const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 4)
      this.sms_code = sanitizedValue

      if (!this.sms_code) {
        return (this.codeErrorMsg = errMsgMap.codeReuqired)
      }
      if (/^\d{4}$/.test(this.sms_code)) {
        this.codeErrorMsg = ''
      } else {
        this.codeErrorMsg = errMsgMap.codeRule
      }
    },
    checkInputMobile(event) {
      const value = event.target.value
      const sanitizedValue = value.replace(/\D+/g, '')
      this.mobile = sanitizedValue

      if (!this.mobile) {
        return (this.mobileErrorMsg = errMsgMap.mobileReuqired)
      }
      if (/^1[3-9]\d{9}$/.test(this.mobile)) {
        this.mobileErrorMsg = ''
      } else {
        this.mobileErrorMsg = errMsgMap.mobileRule
      }
    },
    startInterval: debounce(
      async function () {
        if (this.sendCodeDisabled) return
        this.isSendingCode = true
        try {
          await this.sendCode(this.mobile)
          let num = 60
          this.codeText = num + 's'
          this.timer = setInterval(() => {
            this.codeText = --num + 's'
            if (num === 0) {
              clearInterval(this.timer)
              this.codeText = '重新获取'
              this.isSendingCode = false
            }
          }, 1000)
        } catch (error) {
          console.log('sendCode', error)
          this.isSendingCode = false
        }
      },
      500,
      true
    ),
    setAgree() {
      this.agree = !this.agree
      if (!this.agree) {
        this.agreeErrorMsg = errMsgMap.agree
      } else {
        this.agreeErrorMsg = ''
      }
    },
    // app授权成功
    appSuccess() {
      this.$emit('login', {
        // 登录类型
        login_type: 'app',
        session_id: this.appAuthInfo.session_id,
        // 是否缓存登录
        cacheLogin: this.cacheLogin,
      })
    },
    showAuthLoading() {
      this.isShowAuthorizeLoading = true
      this.isShowLoginByPhone = false
    },
    wechatJumpError(error) {
      console.log('error', error)
      this.openExternalBrowserGuide = true
    },
    // 扫码授权成功
    scanSucess(val) {
      this.$emit('login', {
        // 登录类型
        login_type: 'qrcode',
        session_id: val.sessionId,
        // 是否缓存登录
        cacheLogin: val.cacheLogin,
      })
    },
    // 手机号登录
    loginByPhone: debounce(
      async function () {
        if (!this.mobile) {
          return (this.mobileErrorMsg = errMsgMap.mobileReuqired)
        }
        if (!this.sms_code) {
          return (this.codeErrorMsg = errMsgMap.codeReuqired)
        }
        if (!this.agree) {
          return (this.agreeErrorMsg = errMsgMap.agree)
        }

        if (this.loginDisabled) return

        this.$emit('login', {
          // 验证码
          sms_code: this.sms_code,
          // 登录手机号
          mobile: this.mobile,
          // 登录类型
          login_type: 'mobile',
          // 是否缓存登录
          cacheLogin: this.cacheLogin,
        })
      },
      500,
      true
    ),
  },
}
</script>
<style scoped lang="less">
.login_container {
  .close_btn {
    position: absolute;
    width: 35px;
    height: 35px;
    top: 16px;
    right: 16px;
    cursor: pointer;
    transform: scale(0.8);

    &::before,
    &::after {
      position: absolute;
      content: '';
      display: block;
      height: 5px;
      width: 42px;
      background: #808080;
      border-radius: 5px;
    }

    &::before {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  .title {
    margin-bottom: 30px;
    font-size: 27px;
    color: #202226;
    text-align: center;
  }

  .main {
    position: relative;
    width: 490px;
    background: #fff;
    border-radius: 16px;
    padding: 36px 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;

    .error_msg {
      position: absolute;
      left: 11px;
      bottom: -4px;
      transform: translateY(100%);
      font-size: 14px;
      color: #d40303;
    }

    .input_wrap {
      position: relative;
      width: 100%;
      font-size: 0;
      display: flex;
      align-items: center;
      height: 46px;
      margin-bottom: 20px;
      background: #f4f4f4;
      border-radius: 10px;
      border: 2px solid #eae9e9;

      input {
        appearance: none;
        flex-grow: 1;
        border: none;
        outline: none;
        background: transparent;
        padding-left: 12px;
        font-size: 17px;
        color: #202226;

        &::placeholder {
          color: #b2afaf;
        }

        &:focus {
          outline: none;
          background-color: transparent;

          &::-webkit-contacts-auto-fill-button {
            opacity: 0;
          }
        }
      }

      .line {
        background: #d0cdcd;
        height: 21px;
        width: 1px;
      }

      .prepend {
        text-align: center;
        width: 54px;
        font-size: 17px;
        color: #202226;
      }

      .afterpend {
        text-align: center;
        width: 86px;
        font-size: 15px;
        color: #07c261;
        cursor: pointer;

        &.disabled {
          color: #b2afaf;
        }
      }
    }

    .tips_con {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #787878;
      white-space: nowrap;
      margin-bottom: 10px;

      .checkbox {
        width: 28px;
        height: 28px;
        margin-right: 2px;
        cursor: pointer;
      }

      a {
        color: #07c261;
        text-decoration: none;
      }

      .error_msg {
        left: 30px;
      }
    }

    .btn_wrapper {
      width: 100%;
      margin-top: 20px;
    }

    .other_login {
      margin: 24px auto 0;
      width: 100%;
      display: flex;
      justify-content: center;
      position: relative;
      z-index: 1;
      .login_icon {
        width: 54px;
        height: 54px;
        cursor: pointer;
        margin-left: 54px;
        &:first-child {
          margin-left: 0;
        }
      }
    }

    .login_btn {
      width: 100%;
      height: 53px;
      background: #07c261;
      border-radius: 10px;
      font-size: 22px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &.disabled {
        background: #c5c5c5;
        cursor: not-allowed;
      }
    }

    .loginByApp_btn {
      display: none;
    }
  }
}

@media (max-width: 1024px) {
  .login_container {
    .close_btn {
      width: 0.35rem;
      height: 0.35rem;
      top: 0.16rem;
      right: 0.16rem;
      transform: scale(0.8);

      &::before,
      &::after {
        height: 0.05rem;
        width: 0.42rem;
        border-radius: 0.05rem;
      }
    }

    .title {
      margin-bottom: 0.44rem;
      font-size: 0.38rem;
    }

    .main {
      width: 6rem;
      border-radius: 0.16rem;
      padding: 0.48rem;

      .error_msg {
        left: 0.11rem;
        bottom: -0.14rem;
        font-size: 0.22rem;
      }

      .input_wrap {
        height: 0.66rem;
        margin-bottom: 0.24rem;
        border-radius: 0.1rem;
        border: 1px solid #eae9e9;

        input {
          padding-left: 0.12rem;
          font-size: 0.24rem;
        }

        .line {
          height: 0.21rem;
          width: 1px;
        }

        .prepend {
          width: 0.72rem;
          font-size: 0.24rem;
        }

        .afterpend {
          width: 1.5rem;
          font-size: 0.24rem;
        }

        &.sms_code_wrap {
          margin-bottom: 0.32rem;
        }
      }

      .input_wrap_error {
        margin-bottom: 0.4rem;
      }
      .tips_con {
        font-size: 0.22rem;
        margin-bottom: 0.24rem;

        .checkbox {
          width: 0.35rem;
          height: 0.35rem;
        }

        .error_msg {
          left: 0.42rem;
        }
      }

      .btn_wrapper {
        width: 100%;
        margin-top: 0.2rem;

        .login_icon {
          width: 0.75rem;
          height: 0.75rem;
          margin-left: 0.54rem;
        }
      }

      .login_btn {
        width: 100%;
        height: 0.75rem;
        border-radius: 0.1rem;
        font-size: 0.32rem;
      }

      .loginByApp_btn {
        position: relative;
        margin-top: 0.24rem;
        width: 100%;
        height: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.32rem;
        color: #07c261;
        line-height: 0.24rem;
        border: 1px solid #eae9e9;
        box-sizing: border-box;
        border-radius: 0.1rem;

        .prve_icon {
          margin-right: 0.1rem;
          width: 0.25rem;
          height: 0.3rem;
        }
      }
    }

    .authorize_loading,
    .authorize_fail {
      position: relative;
      width: 6rem;
      background: #fff;
      padding: 4.1rem 0.48rem 0.43rem;
      box-sizing: border-box;
      border-radius: 0.16rem;

      .bg_con {
        position: absolute;
        top: -0.42rem;
        left: 50%;
        transform: translateX(-50%);
        width: 4.77rem;

        .bg_item {
          width: 4.77rem;
          height: 4.44rem;
        }

        .bg_icon {
          width: 1rem;
          height: 1rem;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          animation: rotate 2s linear infinite;

          @keyframes rotate {
            from {
              transform: translate(-50%, -50%) rotate(0deg);
            }

            to {
              transform: translate(-50%, -50%) rotate(360deg);
            }
          }
        }

        .bg_text {
          position: absolute;
          bottom: 0.48rem;
          left: 50%;
          transform: translateX(-50%);
          font-size: 0.34rem;
          color: #202226;
          line-height: 0.44rem;
        }
      }

      .tips {
        font-size: 0.24rem;
        color: #626d79;
        line-height: 0.44rem;
        text-align: center;
      }
    }

    .wechat_guide_con {
      .wechat_guide_pic {
        position: absolute;
        right: 0.52rem;
        top: 0;
        width: 4.15rem;
        height: 3.86rem;
      }
    }
  }
}
</style>
